<template>
  <div v-if="visible" class="ai-summary-container mt-3 w-100">
    <!-- AC-01: Loading skeleton appears within 100ms -->
    <div v-if="loading" class="ai-summary-loading p-3 border rounded shadow-sm bg-white">
      <div class="d-flex align-items-center mb-2">
        <b-icon icon="cpu-fill" class="mr-2 text-success" animation="throb"></b-icon>
        <span class="text-muted small font-weight-bold">AI ANALYZING CHART...</span>
      </div>
      <b-skeleton animation="wave" width="85%" height="1.2rem" class="mb-2"></b-skeleton>
      <b-skeleton animation="wave" width="70%" height="1.2rem"></b-skeleton>
    </div>

    <!-- AC-02: Summary replaces skeleton -->
    <div v-else-if="summary" class="ai-summary-box p-3 border rounded shadow-sm mb-3">
      <div class="ai-summary-header d-flex align-items-center mb-2">
        <div class="ai-badge mr-2">
          <b-icon icon="stars" class="ai-icon text-white"></b-icon>
        </div>
        <span class="ai-title font-weight-bold">AI INSIGHT</span>
      </div>
      <p class="ai-text mb-0">{{ summary }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AiSummaryBox',
  computed: {
    ...mapState('aiSummary', ['summary', 'loading', 'error']),
    visible() {
      // AC-05, AC-06: Silent failure - hide on error or if no summary
      return this.loading || (this.summary && !this.error);
    },
  },
};
</script>

<style scoped>
.ai-summary-container {
  max-width: 100%;
}

.ai-summary-box {
  background-color: #f0fff4 !important; /* Premium light green */
  border-color: #c6f6d5 !important;
  border-left: 4px solid #38a169 !important;
  transition: opacity 0.4s ease-in-out;
}

.ai-summary-loading {
  border-left: 4px solid #e2e8f0 !important;
  background-color: #ffffff;
}

.ai-badge {
  background-color: #38a169;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-title {
  color: #2f855a;
  font-size: 0.7rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.ai-text {
  font-family: 'Work Sans', sans-serif;
  color: #2d3748;
  font-size: 0.95rem;
  line-height: 1.5;
  font-weight: 500;
}

/* AC-08: Text selection remains available */
.ai-text::selection {
  background: #c6f6d5;
}
</style>
